import { NavigationExtras } from '@angular/router';
import { IActionPayload } from '../interfaces/action-payload.interface';

export enum GsmsRouterActionTypes {
  GO_TO_SELECT_PRODUCT = '[Router] GO_TO_SELECT_PRODUCT',
  GO_TO_SELECT_TYPE = '[Router] GO_TO_SELECT_TYPE',
  GO_TO_WORK_ITEM_DETAILS = '[Router] GO_TO_WORK_ITEM_DETAILS',
}

export interface IGsmsRoutePayload {
    query?: object;
    extras?: NavigationExtras;
}

export interface IWorkItemPayload extends IGsmsRoutePayload { workItemID: string; }

export class GoToSelectProduct implements IActionPayload {
  public readonly type = GsmsRouterActionTypes.GO_TO_SELECT_PRODUCT;
  public constructor(public payload: IWorkItemPayload) {}
}

export class GoToSelectType implements IActionPayload {
    public readonly type = GsmsRouterActionTypes.GO_TO_SELECT_TYPE;
    public constructor(public payload: IWorkItemPayload) {}
}

export class GoToWorkItemDetails implements IActionPayload {
    public readonly type = GsmsRouterActionTypes.GO_TO_WORK_ITEM_DETAILS;
    public constructor(public payload: IWorkItemPayload) {}
}

export type GsmsRouterActionsUnion =
  | GoToSelectProduct
  | GoToSelectType
  | GoToWorkItemDetails;
